module.exports = __webpack_public_path__ + "static/media/heather.495b0005.jpg";